import type { VideoOpenDetail } from './imos-video-modal';

class ImosVideoTrigger extends HTMLElement {
  connectedCallback(): void {
    this.addEventListener('click', this.handleClick);
    this.style.cursor = 'pointer';
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleClick);
  }

  private handleClick = (): void => {
    const detail: VideoOpenDetail = {
      title: this.dataset.title || '',
      videoId: this.dataset.videoId || '',
      posterUrl: this.dataset.posterUrl || '',
      embedHtml: this.dataset.embedHtml || '',
    };
    window.dispatchEvent(
      new CustomEvent('imos-video-open', { bubbles: true, composed: true, detail }),
    );
  };
}

customElements.define('imos-video-trigger', ImosVideoTrigger);
